// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oxya","title":"styles_title__hbA6Q"};